import axios from "axios";
import { API_URL } from "../config/env";

class DepositService {
  static get_addresses = (tokens) => {
    return axios.get(`${API_URL}/deposit/wallet-addresses`, {
      headers: {
        Authorization: `Bearer ${tokens.access.token}`,
      },
    });
  };

  static update_addresses = (tokens, data) => {
    return axios.put(`${API_URL}/deposit/wallet-addresses`, data, {
      headers: {
        Authorization: `Bearer ${tokens.access.token}`,
      },
    });
  };

  static get_user_deposits = (tokens) => {
    return axios.get(`${API_URL}/deposit`, {
      headers: {
        Authorization: `Bearer ${tokens.access.token}`,
      },
    });
  };

  static change_deposit_status = (tokens, data) => {
    return axios.post(`${API_URL}/deposit/change-status`, data, {
      headers: {
        Authorization: `Bearer ${tokens.access.token}`,
      },
    });
  };
}

export default DepositService;
